export default __webpack_public_path__ + "static/media/dog11.c99b95a0.JPG";